// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { GroundTruthTriggerSource } from "./GroundTruthTriggerSource.gen";
import { GroundTruthJobStatus } from "./GroundTruthJobStatus.gen";
import { TargetTypes } from "./Shared.TargetTypes.gen";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsNotEmpty } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface IGroundTruthJob {
	promotedToBaseline: boolean;

	id: string | undefined;

	facilityId: string;

	requestedById: string | undefined;

	source: GroundTruthTriggerSource;

	status: GroundTruthJobStatus;

	requestDate: string | undefined;

	asOfDate: string;

	completedDate: string | undefined;

	photoCount: number;

	targetFilter: TargetTypes | number ;

	totalCount: number | undefined;

	classCountsJson: string | undefined;

	errorMessage: string | undefined;

	$type?: string | undefined;
}
export class GroundTruthJob {
	constructor(data?: IGroundTruthJob) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.requestDate) { this.requestDate = new Date(data.requestDate); }
		this.asOfDate = new Date(data.asOfDate);
		if (data.completedDate) { this.completedDate = new Date(data.completedDate); }
	}

	promotedToBaseline: boolean = false;

	id: string | undefined;

	@IsNotEmpty()
	facilityId: string = "";

	requestedById: string | undefined;

	source: GroundTruthTriggerSource = 0;

	status: GroundTruthJobStatus = 0;

	requestDate: Date | undefined = new Date();

	@IsNotEmpty()
	asOfDate: Date = new Date();

	completedDate: Date | undefined;

	@IsNotEmpty()
	photoCount: number = 0;

	targetFilter: TargetTypes | number  = 0;

	totalCount: number | undefined;

	classCountsJson: string | undefined;

	errorMessage: string | undefined;

	static $type: string = "CoreApi.Models.GroundTruthJob, ";
	$type?: string | undefined = GroundTruthJob.$type;
}

